module.exports = __webpack_public_path__ + "img/zk-icon-label.2ce856e1.svg";